var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideosTablet = function SvgIllVideosTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 242,
    viewBox: "0 0 768 242",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 1695,
    r: 1592,
    fill: "#3CC265"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1523_9394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 768,
    height: 242
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 242,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1523_9394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1523_9394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -252,
    y: -23,
    width: 1292,
    height: 257
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.5 105C78.6537 105 -149.688 187.514 -247 227.359L-252 -23H1040L1033.5 234C896.791 179.545 668.928 105 394.5 105Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1523_9394)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.928 105.931C690.928 105.931 690.432 106.875 691.964 106.641L700.259 105.811",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M662.8 126.55C662.8 126.55 662.246 123.138 668.022 119.1C673.797 115.063 677.834 110.884 679.509 108.592C679.509 108.592 678.671 105.322 676.309 102.533L679.509 100.93C679.509 100.93 681.176 105.527 681.942 105.315C682.709 105.102 682.985 104.477 682.985 103.292V97.6517L687.718 94.3809L692.521 99.9506C692.521 99.9506 691.826 104.059 691.131 105.449C690.435 106.84 691.272 106.705 691.968 106.634L705.193 105.315V110.047L691.968 112.232C691.592 112.296 691.343 112.651 691.421 113.02C691.769 114.779 692.507 119.633 690.882 123.294C690.676 123.755 690.776 124.024 691.031 124.457C692.145 126.337 694.721 132.588 692.252 135.739L688.009 137.477L662.111 130.098L662.807 126.55H662.8Z",
    fill: "#ED1B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M684.106 115.226C684.106 115.226 683.354 112.742 680.388 113.069C677.422 113.395 675.265 118.39 677.316 120.511C679.366 122.633 682.169 122.236 684.397 118.028",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M678.549 118.136C678.549 118.136 678.01 114.9 680.443 114.688C682.877 114.475 683.707 120.009 681.011 120.115C678.315 120.222 679.414 116.703 680.443 116.738C681.472 116.774 681.536 119.108 680.592 118.498",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M662.798 126.55C662.798 126.55 662.166 124.514 665.416 121.264C668.665 118.015 671.78 117.142 675.647 112.863L679.507 108.585L678.776 106.563C678.776 106.563 677.747 104.271 676.598 102.888",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M680.437 103.278C680.437 103.278 677.982 103.185 678.195 105.371L676.599 102.902L676.088 101.546L679.501 100.943L680.43 103.285L680.437 103.278Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M682.985 100.368V102.071C682.985 102.071 685.603 99.1901 692.287 101.219L693.486 98.5444L685.497 92.8115L681.523 99.183L682.978 100.368H682.985Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M701.624 105.676C701.624 105.676 703.547 107.628 701.27 110.7L704.789 110.075L704.675 105.258L701.624 105.676V105.676Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M649.798 85.0449C649.798 85.0449 655.46 84.1541 659.458 87.6451L663.553 83.4092C663.553 83.4092 654.636 81.9669 653.085 79.3305L649.418 81.4712L649.805 85.043L649.798 85.0449Z",
    fill: "#ED1B98",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M712.762 102.625C712.521 98.7798 703.709 96.1404 703.148 107.11C702.666 109.593 701.623 114.318 706.994 116.241C712.365 118.164 715.082 115.12 715.245 111.757C715.245 111.757 720.134 111.679 720.212 106.953C720.29 102.228 714.366 101.185 712.762 102.625Z",
    fill: "#32BF5E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M687.723 97.1123C687.723 97.1123 674.931 108.564 663.791 100.518C652.652 92.4721 656.469 75.5572 670.184 75.0393C670.184 75.0393 673.689 65.3402 687.723 68.3344C687.723 68.3344 690.817 57.5 704.95 58.018C719.084 58.5359 718.977 72.2864 718.977 72.2864C718.977 72.2864 730.01 76.288 725.576 89.5844C721.241 99.2976 713.819 99.695 707.625 97.6303C707.625 97.6303 700.509 107.223 687.716 97.1123H687.723Z",
    fill: "#32BF5E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M707.632 97.6249C707.632 97.6249 700.473 96.4542 699.416 87.4717",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M693.06 90.252C693.06 90.252 690.556 95.701 687.725 97.2478",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M697.516 58.9619C697.516 58.9619 688.079 61.9986 687.725 68.3346Z",
    fill: "#32BF5E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M697.516 58.9619C697.516 58.9619 688.079 61.9986 687.725 68.3346",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M659.179 81.2334C659.066 81.4888 658.959 81.7372 658.86 81.9926C653.035 96.4596 666.026 101.873 666.026 101.873",
    fill: "#32BF5E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M659.179 81.2334C659.066 81.4888 658.959 81.7372 658.86 81.9926C653.035 96.4596 666.026 101.873 666.026 101.873",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M647.469 74.2728C647.469 74.2728 643.773 69.3536 638.822 73.9848C633.871 78.616 641.123 82.4177 641.123 82.4177C641.123 82.4177 639.791 87.2381 643.401 88.6065C647.01 89.975 649.817 87.5395 652.069 82.8577C654.322 78.1759 655.474 78.1116 654.34 73.9568C653.206 69.8019 647.091 72.162 647.467 74.2659L647.469 74.2728Z",
    fill: "#32BF5E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M654.624 82.719C654.624 82.719 653.873 82.2211 652.342 82.2508C650.811 82.2806 648.879 82.5332 648.879 81.0022C648.879 79.4711 649.347 77.9104 649.444 76.6989C649.54 75.4874 649.347 72.1726 650.692 72.0834C652.038 71.9942 652.38 72.7672 652.625 74.0158C652.625 74.0158 653.465 71.8679 654.646 72.0611C655.828 72.2544 655.724 72.678 655.962 74.4543C656.148 75.0489 655.992 75.3611 657.24 75.703C658.489 76.0448 661.952 76.7658 664.353 79.8873C665.319 81.4481 665.289 86.3757 661.454 87.4386C657.619 88.5014 656.527 87.1264 656.46 85.8183C656.415 84.8744 656.675 84.265 657.092 83.9305C657.248 83.8042 657.426 83.715 657.619 83.663C658.303 83.4771 658.965 83.2542 658.965 83.2542C658.965 83.2542 656.623 83.4697 654.624 82.7265V82.719Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1523_9394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 648,
    y: 72,
    width: 17,
    height: 16
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M654.624 82.719C654.624 82.719 653.873 82.2211 652.342 82.2508C650.811 82.2806 648.879 82.5332 648.879 81.0022C648.879 79.4711 649.347 77.9104 649.444 76.6989C649.54 75.4874 649.347 72.1726 650.692 72.0834C652.038 71.9942 652.38 72.7672 652.625 74.0158C652.625 74.0158 653.465 71.8679 654.646 72.0611C655.828 72.2544 655.724 72.678 655.962 74.4543C656.148 75.0489 655.992 75.3611 657.24 75.703C658.489 76.0448 661.952 76.7658 664.353 79.8873C665.319 81.4481 665.289 86.3757 661.454 87.4386C657.619 88.5014 656.527 87.1264 656.46 85.8183C656.415 84.8744 656.675 84.265 657.092 83.9305C657.248 83.8042 657.426 83.715 657.619 83.663C658.303 83.4771 658.965 83.2542 658.965 83.2542C658.965 83.2542 656.623 83.4697 654.624 82.7265V82.719Z",
    fill: "#F6D703"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1523_9394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.028 80.9944C661.999 80.9944 663.596 79.3972 663.596 77.4269C663.596 75.4566 661.999 73.8594 660.028 73.8594C658.058 73.8594 656.461 75.4566 656.461 77.4269C656.461 79.3972 658.058 80.9944 660.028 80.9944Z",
    fill: "url(#paint0_radial_1523_9394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.765 83.0315C649.735 83.0315 651.332 81.4343 651.332 79.464C651.332 77.4937 649.735 75.8965 647.765 75.8965C645.794 75.8965 644.197 77.4937 644.197 79.464C644.197 81.4343 645.794 83.0315 647.765 83.0315Z",
    fill: "url(#paint1_radial_1523_9394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.038 90.6418C661.008 90.6418 662.606 89.0446 662.606 87.0743C662.606 85.1041 661.008 83.5068 659.038 83.5068C657.068 83.5068 655.471 85.1041 655.471 87.0743C655.471 89.0446 657.068 90.6418 659.038 90.6418Z",
    fill: "url(#paint2_radial_1523_9394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.562 85.2092C666.105 85.2092 667.357 83.9581 667.357 82.4147C667.357 80.8713 666.105 79.6201 664.562 79.6201C663.019 79.6201 661.768 80.8713 661.768 82.4147C661.768 83.9581 663.019 85.2092 664.562 85.2092Z",
    fill: "url(#paint3_radial_1523_9394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.98 85.2092C656.523 85.2092 657.775 83.9581 657.775 82.4147C657.775 80.8713 656.523 79.6201 654.98 79.6201C653.437 79.6201 652.186 80.8713 652.186 82.4147C652.186 83.9581 653.437 85.2092 654.98 85.2092Z",
    fill: "url(#paint4_radial_1523_9394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.98 75.4651C656.523 75.4651 657.775 74.2139 657.775 72.6705C657.775 71.1271 656.523 69.876 654.98 69.876C653.437 69.876 652.186 71.1271 652.186 72.6705C652.186 74.2139 653.437 75.4651 654.98 75.4651Z",
    fill: "url(#paint5_radial_1523_9394)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M653.815 76.8764C654.361 76.8764 654.803 76.4338 654.803 75.8879C654.803 75.342 654.361 74.8994 653.815 74.8994C653.269 74.8994 652.826 75.342 652.826 75.8879C652.826 76.4338 653.269 76.8764 653.815 76.8764Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M653.584 76.7349C654.003 76.7349 654.342 76.3955 654.342 75.9768C654.342 75.5582 654.003 75.2188 653.584 75.2188C653.166 75.2188 652.826 75.5582 652.826 75.9768C652.826 76.3955 653.166 76.7349 653.584 76.7349Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M651.77 77.0029C651.77 77.0029 652.126 77.8874 652.959 77.0624",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M651.276 76.6469C651.822 76.6469 652.264 76.2043 652.264 75.6584C652.264 75.1125 651.822 74.6699 651.276 74.6699C650.73 74.6699 650.287 75.1125 650.287 75.6584C650.287 76.2043 650.73 76.6469 651.276 76.6469Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M651.045 76.5064C651.464 76.5064 651.803 76.167 651.803 75.7483C651.803 75.3296 651.464 74.9902 651.045 74.9902C650.626 74.9902 650.287 75.3296 650.287 75.7483C650.287 76.167 650.626 76.5064 651.045 76.5064Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M654.652 72.0607C654.652 72.0607 655.633 71.9269 655.804 73.1904C655.975 74.4539 655.143 75.2789 657.952 75.8884C660.762 76.4978 662.813 77.9397 663.92 79.3444L664.181 79.6491",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M148.379 94.4491V91.766L150.708 89L153.474 91.7208V94.4491",
    fill: "#ED1B98"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.709 89H160.039L162.715 91.6756L153.475 91.7208L150.709 89Z",
    fill: "#0066FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.715 91.6758H153.475V94.6905H162.715V91.6758Z",
    fill: "#FCAEE0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.622 98.4346L125 113.29H131.24L142.342 102.188L136.622 98.4346Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M178.204 112.546V129.413H152.436V108.506L178.204 112.546Z",
    fill: "#FCAEE0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.088 110.096L155.261 113.872H178.052V130.415",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.791 129.414V108.311L139.644 94.624L152.328 109.607V128.509L128.791 129.414Z",
    fill: "#ED1B98"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.315 106.011C140.667 106.011 141.764 104.915 141.764 103.562C141.764 102.209 140.667 101.112 139.315 101.112C137.962 101.112 136.865 102.209 136.865 103.562C136.865 104.915 137.962 106.011 139.315 106.011Z",
    fill: "#F6D703"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.165 109.614H129.17V129.421H152.165V109.614Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.165 109.614L129.17 129.421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.165 129.421L129.17 109.614",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.607 94.6301L139.788 94.4492L155.518 113.11L181.896 113.186V113.525L155.48 113.578L139.607 94.6301Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M165.881 94.4268L139.789 94.4494L155.518 113.11L181.897 113.186L165.881 94.4268Z",
    fill: "#0066FF"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3031 144.598C59.3031 144.598 53.8475 142.031 53.9547 137.985C54.0618 133.938 59.4102 137.126 60.2756 140.952C60.2756 140.952 59.6987 135.026 63.4401 131.208C67.1816 127.391 68.7886 130.129 68.5578 132.402C68.3271 134.674 68.6155 139.015 63.7286 143.233L59.3031 144.598V144.598Z",
    fill: "#3CC265"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M284.492 109.229C284.492 109.229 282.15 107.398 282.754 105.264C283.358 103.131 284.939 103.828 285.096 106.028C285.096 106.028 286.546 101.869 289.203 102.869C291.86 103.869 286.792 109.403 286.104 109.362C285.416 109.321 284.497 109.234 284.497 109.234L284.492 109.229Z",
    fill: "#32BF5E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M552.172 116.943C552.172 116.943 548.478 114.763 549.063 109.336C549.647 103.909 551.978 105.301 552.499 106.622C553.021 107.944 553.919 111.197 553.592 112.028C553.418 112.468 553.953 112.845 554.19 112.12C554.426 110.835 553.48 108.412 553.668 107.29C553.856 106.168 555.679 98.624 558.267 99.0146C560.855 99.4053 557.293 110.529 555.804 111.921C555.804 111.921 559.303 108.284 561.182 109.67C563.06 111.055 558.656 116.951 555.414 116.951H552.172V116.943Z",
    fill: "#3CC265"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.039 142.69C162.039 142.69 175.054 137.681 185.115 145.817C185.115 145.817 194.777 136.633 210.206 143.055C210.206 143.055 219.125 135.21 234.338 137.328C234.338 137.328 223.336 132.638 211.444 137.631C211.444 137.631 196.152 129.927 183.436 140.167C183.436 140.167 174.886 137.132 162.033 142.691L162.039 142.69Z",
    fill: "#F6D703"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M635.198 180.2C635.198 180.2 648.079 178.043 655.793 187.397C655.793 187.397 666.387 180.778 679.342 189.563C679.342 189.563 689.002 184.033 702.569 188.837C702.569 188.837 693.348 182.466 681.495 184.821C681.495 184.821 668.902 174.88 655.315 181.897C655.315 181.897 648.038 177.507 635.198 180.2V180.2Z",
    fill: "#F6D703"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M649.311 125.986C649.311 125.986 697.463 133.891 723.5 139.5",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M545.299 136.134C545.299 136.134 560.336 134.516 568.815 145.505C568.815 145.505 581.409 138.734 595.998 149.414C595.998 149.414 607.458 143.809 622.947 150.045C622.947 150.045 612.573 142.316 598.724 144.218C598.724 144.218 584.615 132.268 568.523 139.296C568.523 139.296 560.301 133.912 545.291 136.133L545.299 136.134Z",
    fill: "#F6D703"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(660.028 77.4269) scale(3.5675 3.56751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(647.765 79.464) scale(3.5675 3.56751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(659.038 87.0743) scale(3.5675 3.5675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(664.562 82.4147) scale(2.79453 2.79455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(654.98 82.4147) scale(2.79453 2.79455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1523_9394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(654.98 72.6705) scale(2.79453 2.79455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideosTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos_tablet.e894aa67.svg";
export { ForwardRef as ReactComponent };